export default __webpack_public_path__ + "static/media/pic6.e0e6d52d.jpg";